import { takeLatest, call, put } from 'redux-saga/effects';
import getBrowserHistory from 'yoda-core-components/lib/navigation/history/getBrowserHistory';
import showGlobalLoader from 'yoda-checkout-components/lib/actions/ShowGlobalLoaderAction';
import {
    URL_CHECKOUT_BOPIS,
    URL_CHECKOUT_SHIPPING,
    URL_CHECKOUT_PAYMENT,
} from 'yoda-checkout-components/lib/common/Constants';
import { stringifyQuery } from 'yoda-core-components/lib/navigation/query/makeQuery';
import { INIT_NEW_CHECKOUT_SECTIONS_CLIENT_SIDE_ACTIONS } from '../actionTypes/CheckoutActionTypes';
// eslint-disable-next-line import/no-cycle
import cartDetailsSaga from './CartDetailsSaga';

export const newBOPISSelector = (state) => state.newBOPIS;
export const newShippingSelector = (state) => state.newShipping;
export const newPaymentSelector = (state) => state.newPayment;

export function* initCheckoutSectionFromClientSideActions(request) {
    const { pageName, isLoadedFromReview } = request;
    const options = {
        includeServiceLevels: true,
        isLoadedFromReview,
    };

    let sectionName = 'delivery';
    let renderFrom = null;
    switch (pageName) {
        case URL_CHECKOUT_BOPIS:
            renderFrom = 'bopis';
            break;
        case URL_CHECKOUT_SHIPPING:
            renderFrom = 'shipping';
            break;
        case URL_CHECKOUT_PAYMENT:
            sectionName = 'payment';
            renderFrom = 'payment';
            break;
        default:
            break;
    }
    options.pageName = sectionName;
    options.renderFrom = renderFrom;
    options.ignoreDAReadyEvent = true;
    const checkoutURLConfig = {
        pathname: pageName,
    };
    if (isLoadedFromReview) {
        checkoutURLConfig.search = stringifyQuery({
            from: 'review',
        });
    }
    yield put(showGlobalLoader(true));
    yield call(cartDetailsSaga, { payload: options });
    getBrowserHistory().push(checkoutURLConfig);
}

const watchInitCheckoutSectionFromClientSideActions = function* watchInitCheckoutSectionFromClientSideActions() {
    yield takeLatest(
        INIT_NEW_CHECKOUT_SECTIONS_CLIENT_SIDE_ACTIONS,
        initCheckoutSectionFromClientSideActions
    );
};
watchInitCheckoutSectionFromClientSideActions.sagaName =
    'watchInitCheckoutSectionFromClientSideActions';

export default watchInitCheckoutSectionFromClientSideActions;
